import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Row, Col, Table, Input, Label, Modal, ModalHeader, ModalBody } from "reactstrap";
import axios from "axios";
import moment from "moment";
import Header from "../../../layout/Header/Header";

function ListadoProcesosSalida() {
  const { user } = useContext(AuthContext);
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_ARTICULOS_PROCESOS_SALIDA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  const [procesos, setProcesos] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [modal, setModal] = useState(false);
  const [detalle, setDetalle] = useState([]);
  const [detalleInfo, setDetalleInfo] = useState("");

  useEffect(() => {
    axios.get(URL_PROCESOS_SALIDA, { headers })
      .then((res) => {
        const data = (res.data || [])
          .filter((a) => a.is_active === "Si")
          .map((a) => ({
            _id: a._id,
            numero: a.idProcesosSalida,
            fecha: a.fecha,
            fechaCompromiso: a.fechaCompromiso,
            maquilero: a.proveedores?.[0]?.nombre_comercial || "",
            pedido: a.pedidos?.[0]?.idPedido || "",
            observaciones: a.observaciones,
            status: a.status,
            piezas: a.totalPiezas || 0,
            total: a.totalGeneral || 0,
          }))
          .sort((a, b) => (a.numero < b.numero ? 1 : -1));
        setProcesos(data);
      })
      .catch((err) => console.log(err));
  }, []); // eslint-disable-line

  function verDetalle(id, numero, maquilero) {
    setDetalle([]);
    setDetalleInfo(`Salida ${numero} - ${maquilero}`);
    axios.get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${id}`, { headers })
      .then((res) => {
        setDetalle(
          (res.data || []).filter((a) => a.is_active === "Si").map((a) => ({
            articulo: a.articulosPedido?.[0]?.articulos?.[0]
              ? `${a.articulosPedido?.[0]?.articulos?.[0]?.codigo || ""} ${a.articulosPedido?.[0]?.articulos?.[0]?.nombre || ""}`.trim() : "",
            color: a.colores?.[0] ? `${a.colores?.[0]?.name}` : "",
            talla: a.tallas?.[0]?.name || "",
            salida: a.cantidadSalida || 0,
            entrada: a.cantidadEntrada || 0,
            pendiente: (a.cantidadSalida || 0) - (a.cantidadEntrada || 0),
          }))
        );
        setModal(true);
      })
      .catch((err) => console.log(err));
  }

  const filtrados = procesos.filter((a) => {
    const t = `${a.numero} ${a.maquilero} ${a.pedido} ${a.status} ${a.observaciones}`.toLowerCase();
    return t.includes(busqueda.toLowerCase());
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_procesos ? (
        <div className="card container col-11">
          <Row>
            <Col md={8}>
              <Button href="/MenuProduccion" className="btn btn-danger" size="sm">Regresar</Button>{" "}
              <Button href="/ProcesosSalidaCreate" className="btn btn-success" size="sm">Nueva Salida</Button>
            </Col>
            <Col md={4}>
              <Label>Buscar</Label>
              <Input type="text" value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
            </Col>
          </Row>
          <h3 align="center">Salidas a Maquila</h3>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th className="tituloTabla">Numero</th>
                <th className="tituloTabla">Fecha</th>
                <th className="tituloTabla">Compromiso</th>
                <th className="tituloTabla">Maquilero</th>
                <th className="tituloTabla">Pedido</th>
                <th className="tituloTabla">Status</th>
                <th className="tituloTabla" align="right">Piezas</th>
                <th className="tituloTabla" align="right">Total</th>
                <th className="tituloTabla">Detalle</th>
              </tr>
            </thead>
            <tbody>
              {filtrados.map((a) => (
                <tr key={a._id}>
                  <td>{a.numero}</td>
                  <td>{a.fecha}</td>
                  <td>{a.fechaCompromiso}</td>
                  <td>{a.maquilero}</td>
                  <td>{a.pedido}</td>
                  <td>{a.status}</td>
                  <td align="right">{new Intl.NumberFormat("en-US").format(a.piezas)}</td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.total)}
                  </td>
                  <td>
                    <Button color="info" size="sm" onClick={() => verDetalle(a._id, a.numero, a.maquilero)}>
                      <i className="fas fa-list"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      <Modal size="lg" isOpen={modal} toggle={() => setModal(!modal)}>
        <ModalHeader toggle={() => setModal(!modal)}>{detalleInfo}</ModalHeader>
        <ModalBody>
          <Table size="sm" striped bordered>
            <thead>
              <tr>
                <th>Articulo</th><th>Color</th><th>Talla</th>
                <th align="right">Salida</th><th align="right">Entrada</th><th align="right">Pendiente</th>
              </tr>
            </thead>
            <tbody>
              {detalle.map((d, i) => (
                <tr key={i}>
                  <td>{d.articulo}</td><td>{d.color}</td><td>{d.talla}</td>
                  <td align="right">{d.salida}</td><td align="right">{d.entrada}</td><td align="right">{d.pendiente}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </>
  );
}

export default ListadoProcesosSalida;
